"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankSuggestions = void 0;
const react_1 = __importDefault(require("react"));
const base_suggestions_1 = require("./base-suggestions");
const highlight_words_1 = require("./highlight-words");
const react_dadata_styles_1 = require("./react-dadata.styles");
require("./types");
class BankSuggestions extends base_suggestions_1.BaseSuggestions {
    constructor() {
        super(...arguments);
        this.loadSuggestionsUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/bank';
        this.getLoadSuggestionsData = () => {
            const { count, filterStatus, filterType, filterLocations, filterLocationsBoost, } = this.props;
            const { query } = this.state;
            const requestPayload = {
                query,
                count: count || 10,
            };
            if (filterStatus) {
                requestPayload.status = filterStatus;
            }
            if (filterType) {
                requestPayload.type = filterType;
            }
            if (filterLocations) {
                requestPayload.locations = filterLocations;
            }
            if (filterLocationsBoost) {
                requestPayload.locations_boost = filterLocationsBoost;
            }
            return requestPayload;
        };
        this.getSuggestionKey = (suggestion) => `${suggestion.data.bic}`;
        this.renderOption = (suggestion) => {
            const { renderOption, highlightClassName } = this.props;
            const { query } = this.state;
            return renderOption ? (renderOption(suggestion, query)) : (react_1.default.createElement("div", null,
                react_1.default.createElement(react_dadata_styles_1.StyledSuggestionLineThrough, { liquidated: suggestion.data.state.status === 'LIQUIDATED' },
                    react_1.default.createElement(highlight_words_1.HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: this.getHighlightWords(), text: suggestion.value })),
                react_1.default.createElement(react_dadata_styles_1.StyledSuggestionSubtitle, null,
                    suggestion.data.bic && (react_1.default.createElement(react_dadata_styles_1.StyledSuggestionSubtitleItem, null, suggestion.data.bic)),
                    suggestion.data.address && suggestion.data.address.value && (react_1.default.createElement(react_dadata_styles_1.StyledSuggestionSubtitleItem, null,
                        react_1.default.createElement(highlight_words_1.HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: this.getHighlightWords(), text: suggestion.data.address.value }))))));
        };
    }
}
exports.BankSuggestions = BankSuggestions;
